module.exports = __webpack_public_path__ + "static/media/creating-website.a92a7708.gif";